import dynamic from 'next/dynamic';
import { useState, useEffect, createContext, useContext } from 'react';
const Confetti = dynamic(() => import('react-confetti'), { ssr: false });

const ConfettiContext = createContext(null)
ConfettiContext.displayName = 'ConfettiContext';
export const useConfettiContext = () => useContext(ConfettiContext);

export default function ConfettiContextProvider({ children }) {
    const [showConfetti, setShowConfetti] = useState(false);
    // Add a new state to control the rendering of the Confetti component
    const [renderConfetti, setRenderConfetti] = useState(false);

    // When showConfetti changes to false, start a timeout to remove the Confetti component after the transition
    useEffect(() => {
        if (!showConfetti) {
            const timeoutId = setTimeout(() => {
                setRenderConfetti(false);
            }, 1000); // The timeout should be the same as the transition duration

            return () => clearTimeout(timeoutId);
        } else
            setRenderConfetti(true);
    }, [showConfetti]);

    return <ConfettiContext.Provider value={{ setShowConfetti }}>
        {renderConfetti &&
            <Confetti
                className={`confetti ${showConfetti ? '' : 'fade-out'}`}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore:next-line
                active={showConfetti.toString()}
                numberOfPieces={showConfetti ? 300 : 0}
                config={{
                    angle: 90,
                    spread: 70,
                    startVelocity: 100,
                    elementCount: 50,
                    width: '10px',
                    height: '10px',
                    colors: [
                        '#a864fd',
                        '#29cdff',
                        '#78ff44',
                        '#ff718d',
                        '#fdff6a',
                    ],
                    duration: 3e3,
                    stagger: 0,
                    dragFriction: 0.1,
                    random: Math.random,
                }}
            />
        }
        {children}
    </ConfettiContext.Provider>
}